"use strict";
// Shared utilities for Shopify theme components
function escapeHtml(str) {
    return String(str)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;");
}
function labelValue(label, value) {
    if (value == null ||
        value === "" ||
        (Array.isArray(value) && value.length === 0))
        return "";
    const val = Array.isArray(value) ? value.join(", ") : String(value);
    return `<div class="kv"><span class="k">${escapeHtml(label)}:</span> <span class="v">${escapeHtml(val)}</span></div>`;
}
// Make functions globally available
window.escapeHtml = escapeHtml;
window.labelValue = labelValue;
